import { ref, onMounted } from 'vue';
let analyticsInitialized = false;
export function useCookieConsent() {
    const showConsentModal = ref(false);
    const showInfoModal = ref(false);
    const initGoogleAnalytics = () => {
        if (analyticsInitialized)
            return;
        const gaId = process.env.VUE_APP_GA_ID;
        if (!gaId) {
            console.warn('Google Analytics ID not found');
            return;
        }
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
        };
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);
        window.gtag('js', new Date());
        window.gtag('config', gaId);
        analyticsInitialized = true;
    };
    onMounted(() => {
        const hasConsent = localStorage.getItem('cookieConsent');
        if (!hasConsent) {
            showConsentModal.value = true;
        }
        else if (hasConsent === 'all') {
            initGoogleAnalytics();
        }
    });
    const acceptAllCookies = () => {
        localStorage.setItem('cookieConsent', 'all');
        showConsentModal.value = false;
        initGoogleAnalytics();
    };
    const acceptNecessaryOnly = () => {
        localStorage.setItem('cookieConsent', 'necessary');
        showConsentModal.value = false;
    };
    const showCookieInfo = () => {
        showInfoModal.value = true;
    };
    const hideCookieInfo = () => {
        showInfoModal.value = false;
    };
    return {
        showConsentModal,
        showInfoModal,
        acceptAllCookies,
        acceptNecessaryOnly,
        showCookieInfo,
        hideCookieInfo
    };
}
